import Cell from './Cell';

const AddCellDivider = ({ onAdd, visible = false }) => {
    return (
        <div className={`group relative h-6 flex items-center justify-center transition-all ${visible ? 'opacity-100' : 'opacity-0 hover:opacity-100'}`}>
             <div className="absolute inset-x-0 h-px bg-gray-200 group-hover:bg-blue-200 transition-colors"></div>
             <div className="relative z-10 flex gap-2">
                 <button 
                    onClick={() => onAdd('code')}
                    className="flex items-center gap-1 px-3 py-1 bg-white border border-gray-300 rounded-full text-xs font-medium text-gray-600 shadow-sm hover:text-blue-600 hover:border-blue-400 hover:shadow transition-all transform hover:scale-105"
                 >
                    <span className="text-blue-500 font-bold">+</span> Code
                 </button>
                 <button 
                    onClick={() => onAdd('markdown')}
                    className="flex items-center gap-1 px-3 py-1 bg-white border border-gray-300 rounded-full text-xs font-medium text-gray-600 shadow-sm hover:text-green-600 hover:border-green-400 hover:shadow transition-all transform hover:scale-105"
                 >
                    <span className="text-green-500 font-bold">+</span> Text
                 </button>
             </div>
        </div>
    );
};

function NotebookView({ notebook, onAddCell, onUpdateCell, onDeleteCell, onExecuteCell, onMoveCell, executingCells = new Set() }) {
  
  const handleAddCell = (cellType) => {
    const content = cellType === 'markdown' ? '# New Cell' : '# Write your code here';
    onAddCell(cellType, content);
  };

  return (
    <div className="max-w-5xl mx-auto p-6 pb-40">
      
      {/* Cells */}
      <div className="space-y-0">
        {notebook.cells && notebook.cells.length > 0 ? (
          notebook.cells.map((cell, index) => (
            <div key={cell.cell_id} className="relative">
                {/* Top Divider (only for first cell or special cases, usually we use bottom of prev) */}
                {/* We use bottom dividers effectively */}
                
                <Cell
                    cell={cell}
                    onUpdate={onUpdateCell}
                    onDelete={onDeleteCell}
                    onExecute={onExecuteCell}
                    onMove={onMoveCell}
                    isExecuting={executingCells.has(cell.cell_id)}
                />
                
                {/* Divider between cells */}
                <AddCellDivider onAdd={handleAddCell} />
            </div>
          ))
        ) : (
          <div className="text-center py-12 text-gray-500 border-2 border-dashed border-gray-200 rounded-lg">
            <p className="mb-4">No cells yet.</p>
             <div className="flex justify-center gap-4">
                 <button 
                    onClick={() => handleAddCell('code')}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                 >
                    Add Code Cell
                 </button>
                 <button 
                    onClick={() => handleAddCell('markdown')}
                    className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
                 >
                    Add Markdown Cell
                 </button>
             </div>
          </div>
        )}
      </div>

       {/* Bottom Add Area (Always visible if cells exist) */}
       {notebook.cells && notebook.cells.length > 0 && (
           <div className="mt-8 pb-20">
               <AddCellDivider onAdd={handleAddCell} visible={true} />
           </div>
       )}
    </div>
  );
}

export default NotebookView;
